<template> <!-- we can use functional component v-if="!crmUsers && crmUsers.length==0"-->
  <div>
    <div class="wrapper wrapper-content animated fadeInRight">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-title">
					<h4 >
						CRM Users : {{crmUsers.length}}
					</h4>
				</div>
				<div class="ibox-content">
					<Loading v-if="loading" />

					<table class="table footable  table-stripped footable-loaded" v-if="!loading">
						<thead>
							<tr>
								<th class="col-lg-4 ">Username<span class=""></span></th>
								<th class="col-lg-4 ">CRM email<span class=""></span></th>
								<th class="col-lg-8 ">Extension<span class=""></span></th>
							</tr>
						</thead>
						<tbody>
						<tr class="gradeX" v-for="user in crmUsers" v-bind:key="user.id" data-index="0" style="display: table-row;">
								<td>
									<span class="footable-toggle"></span><!-- ngIf: allow_admin -->
									<input type="checkbox" v-model="selectedItems" :value="user.id" />&nbsp;
									<span>{{user.username}}</span>
								</td><td>{{user.email}}</td>
								<td>{{user.extension}}</td>
								<!-- <router-link :to="{path:'/edit/' + user.id}">{{user.username}}</router-link>

								<td>
									<strong class="ng-binding">(Administrator)</strong>
								</td> -->
							</tr>
							<!-- ngRepeat: number in :numbers:numberList.numbers track by number.number -->
						</tbody>
						<tfoot>
						<tr v-if="allowAdmin"><td colspan="2">
							<router-link class="btn btn-sm btn-success" :to="{path:'/create/', query: {isCRMregister}}">Add user</router-link>
							<button class="btn btn-sm btn-danger" @click="deleteItem()" :disabled="selectedItems.length == 0">Delete</button>
						</td></tr>
						</tfoot>
					</table>
					<button class="btn btn-sm btn-alert" v-if="!loading && !showIframe && crmUsers.length >= 1 && !isCRMregister" @click="createNewCrm()"> Complete Registration To CRM </button>
					<iframe :src="fulliframeurl" v-if="showIframe"
						class="frame"
						scrolling="no"
						name="crm"
						frameborder="0"/>

				</div>
			</div>
		</div>
	</div>
</div>
  </div>
</template>

<script>
import {CrmService} from "../../services/CrmService";
import Loading from "../../components/Loading";
export default {
	data: () => ({
		loading: false,
		crmUsers: [],
		selectedItems: [],
		allowAdmin: false,
		showIframe: false,
		crmIframe: {src: ""},
		isCRMregister: false
	}),
	components: {Loading},
	created() {
		let $injector = this.$root.angularInjector;
		//   let rootScope = $injector.get("$rootScope");
		this.allowAdmin = true;
		//   this.allowAdmin = rootScope.allow_admin;
		//   console.info("allowAdmin?", this.allowAdmin);
		//   rootScope.$watch('allowAdmin', (newVal, oldVal) => {
		// 	  console.info("new allowAdmin valu", newVal, oldVal)
		// 	  this.allowAdmin = newVal;
		//   })

		const CoreApiService = $injector.get("CoreApiService");
		this.SwalService = $injector.get("SwalService");

		this.phonesService = $injector.get("PhonesApiService");
		this.crmService = new CrmService(CoreApiService);
	},
	async mounted() {
		this.load();
		// console.info("vue", this.phones)
	},
	methods: {
		async createNewCrm() {
			console.log("getCrm");
			this.loading = true;
			try {
				if (this.crmUsers.length === 0) {
					alert("you need to add user first");
					return;
				}
				const data = await this.crmService.getIframe(this.crmUsers[0]);
				console.log(data);
				this.buildIframe(data.url);
				this.waitToCloseIframe();
			}
			catch (e) {
				console.log("error:", e);
				alert(e.data.message);
			}

			this.loading = false;
		},
		async waitToCloseIframe() {
			this.showIframe = true;
			let currentDate = (new Date()).getTime();
			let futureDate = (new Date(currentDate + 5/* minutes */ * 60000)).getTime();
			this.trySomething = setInterval(this.kindOfLoop(false, futureDate), 10000);
		},
		async kindOfLoop(isRegister, futureDate) {
			console.log("thing");
			let currentDate = (new Date()).getTime();
			if (currentDate >= futureDate || isRegister) {
				console.log("done");
				this.showIframe = false;
				this.SwalService.popup({title: "crm created!"});
				clearInterval(this.trySomething);
				return;
			}
			let isFinish = await this.checkRegistration();
			return setTimeout(() => this.kindOfLoop(isFinish, futureDate), 5000);
		},
		async checkRegistration() {
			try {
				const result = await this.crmService.checkCustomerRegistration();
				console.log("is register:", result);
				this.isCRMregister = result && result.isRegister;
				// this.showIframe = false;
			}
			catch (e) {
				console.error(e);
			}
			return this.isCRMregister;
		},
		async load() {
			this.loading = true;
			try {
				this.crmUsers = await this.crmService.list();
				this.checkRegistration();
			}
			catch (e) {
				console.log(e);
			}

			this.loading = false;
		},
		async deleteItem() {
			if (this.selectedItems.length === 0) {
				this.SwalService.popup({
					title: "Error",
					type: "warning",
					text: "You must select one or more items to delete"
				});
				return;
			}
			let promises = this.selectedItems.map(id => {
				return this.crmService.delete(id);
			});
			try {
				await Promise.all(promises);
				this.SwalService.popup({
					title: "Deleted"
				}).then(s => {
					this.selectedItems = [];
					this.load();
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: e.message || e.statusCode || e, type: "error"
				}).then(s => {
					this.load();
				});
				// let result = await this.crmService.delete(this.selectedItems[0]);
				// if(result && result.responses[0] && result.responses[0].message == "OK") {
			}
		},
		buildIframe(url) {
			if (this.openIframe) {
				return;
			}
			this.openIframe = true;
			let baseUrl = window.location.href;
			let routeUrl = this.$route.path;
			console.log("base url=> ", baseUrl, routeUrl, this.$route);
			this.crmIframe.src = url;
		}
	},
	computed: {
		fulliframeurl() {
			return this.crmIframe.src;
		}
	}
};
</script>

<style  lang="scss">

.frame {
		width: 100%;
		height: 100%;
		align-items: center;
		min-height: 100vh;
	}
</style>
